import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column email-login" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "d-flex flex-column gap-sm" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  for: "email",
  class: "form-label text-capitalize-first"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  for: "password",
  class: "form-label text-capitalize-first"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "d-flex flex-column text-center" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "register-here" }

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import {onMounted} from "vue";
import {useStore} from "vuex";
import TokenGetRequestDTO from "@/models/request/TokenGetRequestDTO";
import {useNotification} from "@kyvg/vue3-notification";
import {$t} from "@/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailLogin',
  setup(__props) {

const state = reactive({
  password: '' as string,
  email: '' as string
});

const store = useStore()
const notification = useNotification()

const login = async () => {
  try {
    const token = await api.call.token.get({ username: state.email, password: state.password } as TokenGetRequestDTO)
    await store.dispatch('authenticate', token)
    window.location.href = '/'
  } catch (e: any) {
    if (e.response?.data?.[0]?.code === 'EMAIL_NOT_VERIFIED') {
      notification.notify({type: 'error', title: $t('notifications.email_not_verified'), duration: 3000})
    } else {
      notification.notify({type: 'error', title: $t('notifications.incorrect_email_or_password'), duration: 1500})
    }
  }
}

onMounted(async () => {
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref($t)('login_with_email')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref($t)('email')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).email) = $event)),
          id: "email",
          type: "email",
          class: "form-control",
          placeholder: _unref($t)('enter_email')
        }, null, 8, _hoisted_6), [
          [_vModelText, _unref(state).email]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_unref($t)('password')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).password) = $event)),
          id: "password",
          type: "password",
          class: "form-control",
          placeholder: _unref($t)('enter_password')
        }, null, 8, _hoisted_9), [
          [_vModelText, _unref(state).password]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, { to: {name:'forgotPassword'} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)('forgot_password')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (login()), ["prevent"])),
        class: "btn btn-primary w-100 btn-lg"
      }, [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref($t)('login')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, { to: {name:'registration'} }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_unref($t)('dont_have_account')), 1),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref($t)('register_here')), 1)
        ]),
        _: 1,
        __: [3]
      })
    ])
  ]))
}
}

})